import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EmployeeService } from '../../service/employee.service';
import { Department } from '../../models/Department';
import { UserService } from '../../service/user.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { OnboardingService } from '../../service/onboarding.service';

@Component({
  selector: 'app-department-dialog',
  templateUrl: './department-dialog.component.html',
  styleUrls: ['./department-dialog.component.css']
})
export class DepartmentDialogComponent implements OnInit {
  title: string;
  message: any;
  department: Department;
  error: any;
  empCode: number;
  DepartmentForm: FormGroup;
  departmentsList: any[];
  departmetbool: Boolean = false;
  constructor(private toastr: ToastrService, private userService: UserService, public dialogRef: MatDialogRef<DepartmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DepartmentDialog, private _service: EmployeeService, private formBuilder: FormBuilder, private hrSvc: OnboardingService) {
    dialogRef.disableClose = true;
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
  }

  ngOnInit() {
    this.department = new Department();
    this.getDepartments();
    this.empCode = this.userService.getEmpCode();
    const nonWhitespaceRegExp: RegExp = new RegExp("\\S");
    this.DepartmentForm = this.formBuilder.group({
      DepartmentName: ['', [Validators.required, Validators.pattern(nonWhitespaceRegExp)]],
    });
  }
  getDepartments() {
    this.hrSvc.getDepartments().subscribe(
      (data: any) => {
        this.departmentsList = data;
      });
  }

  get f() { return this.DepartmentForm.controls; }
  onConfirm(): void {
    if (!this.DepartmentForm.invalid) {
      this.department.ModifiedBy = this.empCode.toString();
      this.departmentsList.forEach(item => {
        if (item.DepartmentName.toLowerCase() == this.department.DepartmentName.toLowerCase()) {
          this.departmetbool = true;
        }
      });
      if (this.departmetbool == false) {
        this._service.SaveDepartment(this.department).subscribe(data => {
          this.dialogRef.close(this.department);
        }, error => this.error = error)
      }
      else {
        this.toastr.warning("Same department exists");
        this.department.DepartmentName = null;
        this.departmetbool = false;
      }

    }
    else {
      return;
    }


  }
  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}
export class DepartmentDialog {

  constructor(public title: string, public message: any) {
  }
}
